import autoComplete from "@tarekraafat/autocomplete.js"
import {Loader} from "google-maps"

const searchInputs = document.querySelectorAll<HTMLInputElement>("[data-autocomplete]")
const autocompleteInstances = {}

const loader = new Loader("AIzaSyDFls8ZybCm4xfiHad8PdRbWz79p9xXUc0")

searchInputs.forEach((searchInput) => {
  // geolocation button
  const geoComputeButton = searchInput.parentNode?.parentNode?.parentNode?.querySelector("[data-compute-geolocation]") ?? null

  if (!geoComputeButton) return

  // geolocation button on click event
  geoComputeButton.addEventListener("click", () => {
    setTimeout(async () => {
      const google = await loader.load()
      const successCallback = (position) => {
        const latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude)
        new google.maps.Geocoder().geocode({latLng: latlng}, function (results, status) {
          if (status != google.maps.GeocoderStatus.OK || !results[0]) return
          let city = null
          let c, lc, component
          for (let r = 0, rl = results.length; r < rl; r += 1) {
            const result = results[r]
            if (!city && result.types[0] === "locality") {
              for (c = 0, lc = result.address_components.length; c < lc; c += 1) {
                component = result.address_components[c]
                if (component.types[0] === "locality") {
                  city = component.long_name
                  break
                }
              }
            }
            if (city) break
          }
          if (city) searchInput.value = city
          searchInput.focus()
        })
      }

      const errorCallback = (error) => {
        console.log(error)
      }

      navigator.geolocation.getCurrentPosition(successCallback, errorCallback)
    }, 100)
  })

// custom search engine https://github.com/TarekRaafat/autoComplete.js/issues/400
  function searchEngine(query, record) {
    return record;
  }

  // create autocomplete instances
  const autocompleteInstance = new autoComplete({
    searchEngine: searchEngine, // Strict, loose or custom search engine
    debounce: 250,
    diacritics: true,
    selector: "#" + searchInput.id,
    data: {
      src: async (query) => {
        try {
          const sourceApiUrl = searchInput.hasAttribute("data-api-source-endpoint") ? searchInput.getAttribute("data-api-source-endpoint") : "https://api.ci.cz/katalog_firem/1.0/search_rk/?query=__QUERY_STRING__&limit=8"
          const source = await fetch(sourceApiUrl.replace("__QUERY_STRING__", query)) // Fetch Data from external Source
          const data = await source.json() // Data should be an array of `Objects` or `Strings`
          // console.log(data.results)
          return data.results
        } catch (error) {
          return error
        }
      },
      keys: ["label"],
    },
    resultsList: {
      class: "js-autocomplete",
      maxResults: 8,
      noResults: false,
      element: (list: HTMLElement) => {
        geoComputeButton?.classList.remove("d-none")
        list.prepend(geoComputeButton)
      },
    },
    resultItem: {
      element: (item: HTMLElement, data) => {
        if (data.value.label_type) {
          const additionalInfo = document.createElement("span")
          additionalInfo.innerHTML = `<span class="search-autocomplete__label">${data.value.label_type}</span>`
          if (data.value.label_additional) {
            additionalInfo.innerHTML += `<span class="search-autocomplete__value">${data.value.label_additional}</span>`
          }
          item.append(additionalInfo)
        }
        if (data.value.attrs) {
          for (const key in data.value.attrs) {
            item.setAttribute(key, data.value.attrs[key])
          }
        }
      },
    },
  })

  autocompleteInstances[searchInput.id] = autocompleteInstance

  // autocomplete on select event
  searchInput.addEventListener("selection", function (event) {
    searchInput.value = event.detail.selection.value.label_full ? event.detail.selection.value.label_full : event.detail.selection.value.label
    if(event.detail.selection.value.url!==undefined) {
      searchInput.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector("[data-autocomplete-url]").value = event.detail.selection.value.url
    } else if(event.detail.selection.value.redirectUrl!==undefined) {
      window.location.href = event.detail.selection.value.redirectUrl
    }
  })

  searchInput.addEventListener("keyup",function(event) {
    if (searchInput.value === '') {
      if(geoComputeButton?.classList.contains('geo-d-none')) geoComputeButton?.classList.remove('geo-d-none')
    } else {
      if(!geoComputeButton?.classList.contains('geo-d-none')) geoComputeButton?.classList.add('geo-d-none')
    }
  })

  // manage result list and append geo button
  const list = searchInput.parentNode?.querySelector(".js-autocomplete") ?? null
  list?.prepend(geoComputeButton)
  geoComputeButton?.classList.remove("d-none")

  // search input on focus
  searchInput?.addEventListener("focus", function () {
    // const listOfResults = list?.querySelectorAll("li");
    // listOfResults?.forEach(item => {
    //     item.remove();
    // })
    autocompleteInstance.open()
  })
})

const searchFields = document.querySelectorAll<HTMLElement>(".f-search")
searchFields.forEach((searchField) => {
  const getWidth = () => {
    const parentElement = searchField.closest('.g-main-filter__cell-location-search');
    if(parentElement) {
      return parentElement.getBoundingClientRect().width
    } else {
      return searchField.getBoundingClientRect().width
    }
  }

  const setWidthCssVariable = () => {
    searchField.style.setProperty("--autocomplete-width", `${getWidth()}px`)
  }

  const resizeObserver = new ResizeObserver(setWidthCssVariable)
  resizeObserver.observe(searchField)
})
